<script>
    import { createEventDispatcher } from "svelte";

    import { isMobile } from "../../stores";

    const dispatch = createEventDispatcher();

    export let buttons = [-2, -1, 0, 1, 2]; // button control
    export let count; // total amount of data
    export let page = 0; // current page index
    export let pageSize; // selected amount of data show per page

    let pageList = [];

    $: pageCount =
        count % pageSize === 0
            ? Math.floor(count / pageSize) - 1
            : Math.floor(count / pageSize);

    const onChange = (event, page) => {
        const detail = {
            event,
            page,
            firstDataIndex: page * pageSize,
            pageSize,
        };

        dispatch("onPageChange", detail);
    };

    const generatePageList = () => {
        const totalPages = Math.ceil(count / pageSize);
        let list = [];
        for (let i = 0; i < totalPages; i++) {
            list.push({
                value: i,
                name: i + 1,
            });
        }
        return list;
    };

    const onMobilePageSelect = (event) => {
        page = event.target.value;
        const detail = {
            event,
            page: page,
            firstDataIndex: page * pageSize,
            pageSize,
        };

        dispatch("onPageChange", detail);
    };

    $: if (page || pageSize) {
        pageList = generatePageList();
    }
</script>

{#if $isMobile}
    <div class="w-1/4 flex flex-col gap-x-2 ml-2">
        <label class="text-gray-600 font-medium text-sm ml-2" for="mobilePage">
            Page:
        </label>
        <select
            class="select select-sm m-2"
            id="mobilePage"
            on:change={(e) => onMobilePageSelect(e)}
        >
            {#each pageList as pageO}
                <option value={pageO.value} selected={pageO.value == page}>
                    {pageO.name}
                </option>
            {/each}
        </select>
    </div>
{:else}
    <ul>
        <li>
            <button
                class="btn btn-primary btn-sm btn_first text-gray-600"
                disabled={page === 0}
                on:click={(e) => onChange(e, 0)}
            >
                <i class="fa faIcon">&#xf100;</i>
            </button>
        </li>
        <li>
            <button
                class="btn btn-primary btn-sm text-gray-600"
                disabled={page === 0}
                on:click={(e) => onChange(e, page - 1)}
            >
                <i class="fa faIcon">&#xf104;</i>
            </button>
        </li>
        {#each buttons as button}
            {#if page + button >= 0 && page + button <= pageCount}
                <li>
                    {#if page === page + button}
                        <button
                            class="btn btn-primary btn-sm btn-active text-gray-600"
                            on:click={(e) => onChange(e, page + button)}
                        >
                            {page + button + 1}
                        </button>
                    {:else}
                        <button
                            class="btn btn-primary btn-sm text-primary"
                            on:click={(e) => onChange(e, page + button)}
                        >
                            {page + button + 1}
                        </button>
                    {/if}
                </li>
            {/if}
        {/each}
        <li>
            <button
                class="btn btn-primary btn-sm text-gray-600"
                disabled={page > pageCount - 1}
                on:click={(e) => onChange(e, page + 1)}
            >
                <i class="fa faIcon">&#xf105;</i>
            </button>
        </li>
        <li>
            <button
                class="btn btn-sm btn-primary btn_last text-gray-600"
                disabled={page >= pageCount}
                on:click={(e) => onChange(e, pageCount)}
            >
                <i class="fa faIcon">&#xf101;</i>
            </button>
        </li>
    </ul>
{/if}

<style>
    ul {
        float: right;
        list-style: none;
    }

    li {
        float: left;
    }

    .btn {
        border: none;
        border-radius: 0;
        background-color: #f5f6f8;
    }

    .btn_first {
        border-radius: 15px 0 0 15px;
    }

    .btn_last {
        border-radius: 0 15px 15px 0;
    }
</style>
